import * as THREE from "three";
import LpApp from "./LpApp.js";

export default class Renderer {
    constructor()
    {
        console.log("Created Renderer.");
        this.lpApp = new LpApp();

        this.Sizes = this.lpApp.Sizes;
        this.Scene = this.lpApp.Scene;
        this.Canvas = this.lpApp.Canvas;
        this.Camera = this.lpApp.Camera;
        
        this.SetInstance();
    }

    SetInstance()
    {
        this.Instance = new THREE.WebGLRenderer({
            canvas: this.Canvas,
            antialias: true
        });

        this.Instance.toneMapping = THREE.CineonToneMapping;
        this.Instance.toneMappingExposure = 1.75;
        this.Instance.shadowMap.enabled = true;
        this.Instance.shadowMap.type = THREE.PCFSoftShadowMap;
        this.Instance.setClearColor('#211d20');
        this.Resize();
    }
    
    Resize()
    {
        this.Instance.setSize(this.Sizes.width, this.Sizes.height);
        this.Instance.setPixelRatio(this.Sizes.pixelRatio);
    }

    Update()
    {
        this.Instance.render(this.Scene, this.Camera.Instance);
    }
}